import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import UpdateWorkerActionModalContainer from './UpdateWorkerActionModalContainer';
import {setStitchingtaskUpdateWorkerModal} from '../../../../store/slice/ManufSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '95%', xs: '95%' },
  height: { lg: '95%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function UpdateWorkerActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {UpdateWorkerModalOpen, stitchingtaskObj} = useSelector((state)=>state.manufslice.stitchingtaskDashboard);

  useEffect(()=>{
  },[UpdateWorkerModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setStitchingtaskUpdateWorkerModal(false));
  }
  return (
    <Modal
       open={UpdateWorkerModalOpen===undefined?false:UpdateWorkerModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center"
        sx={{borderBottom:'1px solid #e0e0e0'}}>
          <Grid item>
            <Typography variant="h5"  >
              Update Worker @ {stitchingtaskObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item paddingTop={1}> 
            < UpdateWorkerActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}